export default __webpack_public_path__ + "static/media/social52.dbc1ed5c.jpeg";